import { usePostCardContext } from "../PostCardContent";
import { DefaultContentLayout } from "./DefaultContentLayout";
import { ExpandedContentLayout } from "./ExpandedContentLayout";

export const Content = () => {
  const { isOnExpandedPostView } = usePostCardContext();
  return isOnExpandedPostView ? (
    <ExpandedContentLayout />
  ) : (
    <DefaultContentLayout />
  );
};
